import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from "@angular/core";
import { ChoiceList } from "ng/src/app/choice-lists/shared/choice-list.model";
import { Log, LogRoleId } from "ng/src/app/logs/log.model";
import { ChoiceListService } from "ng/src/app/choice-lists/shared/choice-list.service";
import { Subject } from "rxjs";
import { filter, map, switchMap, takeUntil, tap } from "rxjs/operators";

@Component({
	selector: 'lb-choicelist-copier[list]',
	template:`
		<label>To Log</label>
		<log-selector placeholder="Select Log" emptyListMessage="No available Logs" [(ngModel)]="toLog" [memberAsRole]="LOG_ROLE.ADMIN"></log-selector>
		<div *ngIf="logHasList || displaySuccess" class="p-mt-1 p-text-center">
			<p-message *ngIf="logHasList" severity="warn" text="The selected log already has a list by this name"></p-message>
            <p-message *ngIf="displaySuccess" severity="success" text="The list was successfully copied"></p-message>
		</div>
		<button pButton class="p-mt-1" [loading]="checkingLog" loadingIcon="pi pi-spinner pi-spin"
		        [disabled]="!toLog || logHasList || displaySuccess" label="Copy" (click)="proceed()">
		</button>
	`
})
export class ChoicelistCopierComponent implements OnInit, OnDestroy {
	@Input()
	get list() {
		return this._list;
	}
	set list(val) {
		this._list = val;
		this.checkLogSubject.next();
	}
	
	@Output()
	completed = new EventEmitter();
	
	get toLog() {
		return this._toLog;
	}
	set toLog(val) {
		this.displaySuccess = false;
		this._toLog = val;
		this.logHasList = false;
		this.checkLogSubject.next();
	}
	
	get selectedLog() {
		return (Array.isArray(this.toLog) ? this.toLog[0] : null) ?? null;
	}
	
	checkingLog = false;
	logHasList = false;
	checkLogSubject = new Subject();
	displaySuccess = false;
	
	private _list!: ChoiceList;
	private _toLog: [Log] | null = null;
	private onDestroy$ = new Subject();
	
	readonly LOG_ROLE = LogRoleId;
	
	constructor(
		private choiceListService: ChoiceListService
	) {}
	
	ngOnInit(): void {
		this.checkLogSubject.pipe(
			takeUntil(this.onDestroy$),
			filter(() => !!this.selectedLog),
			tap(() => this.checkingLog = true),
			switchMap(() => {
				return this.choiceListService.fetchLists({
					log: this.selectedLog!.id,
					name: this.list.name
				})
			}),
			map(lists => lists.length > 0),
			tap(() => this.checkingLog = false)
		)
			.subscribe((hasList) => this.logHasList = hasList)
	}
	
	ngOnDestroy(): void {
		this.onDestroy$.next();
	}
	
	proceed() {
		this.choiceListService.copyListToLog(this.list!.id, this.selectedLog!.id).subscribe(() => {
			this.displaySuccess = true;
			this.completed.emit();
		});
	}
}